
/** 
* @namespace PosPlatform
*/
import PosPlatform from './PosPlatform';

export default PosPlatform;
